// extracted by mini-css-extract-plugin
export default {"businessAddress":"nIooWRr6YpIBKAT9phiY"};